export const getEndpoint = () =>
  process.env.NODE_ENV === "development"
    ? "http://localhost:8888"
    : "https://englishtree.edu.vn";
